import $ from 'jquery';
import { clGuNm } from '../../common/common';

// 학과 목록
var hakgwaList = [];
// 반 목록
var banArr = [];

const udfSetHakgwaList = (list) => {
  hakgwaList = list;
}

const udfSetLastBan = (ban) => {
  if (sc_rule.SF_END_BAN === '') {
    sc_rule.SF_END_BAN = ban;
    sc_rule.SF_END_BAN_NM = ban + '반';
  }

  if (sc_deduct.SF_END_BAN === '') {
    sc_deduct.SF_END_BAN = ban;
    sc_deduct.SF_END_BAN_NM = ban + '반';
  }

  banArr = [];
  for (let i = 1; i <= ban; i++) {
    banArr.push(i);
  }
}

// 학생정보 검색 조건
var sc_stdt = {
  SF_HAKGWA: '',
  SF_GRADE: '',
  SF_BAN: '',
  SF_STD_STATUS: '1',
  SF_PRMT_YN: 'N',
  searchKeyword: '',
  SF_HAKGWA_NM: '전체',
  SF_GRADE_NM: '전체',
  SF_BAN_NM: '전체',
  SF_STD_STATUS_NM: '재학',
  SF_PRMT_YN_NM: '정상',
}

var stdt_reload = true;

// 상점/벌점 현황 검색 조건
var sc_rule = {
  SF_HAKGWA: '',
  SF_GRADE: '',
  SF_START_BAN: '',
  SF_END_BAN: '',
  SF_SDATE: '',
  SF_EDATE: '',
  SF_KIND: '',
  SF_KIND_SP: '',
  SF_KIND_EP: '',
  SF_CLRL_CD: '',
  SF_CLRL_NM: '',
  SF_HAKGWA_NM: '전체',
  SF_GRADE_NM: '전체',
  SF_START_BAN_NM: '',
  SF_END_BAN_NM: '',
  SF_KIND_NM: '전체',
  SF_CL_CD: '',
  SF_RL_searchkeyword: '',
}

var rule_reload = true;

// 지도 후 차감 관리 검색 조건
var sc_deduct = {
  SF_HAKGWA: '',
  SF_GRADE: '',
  SF_START_BAN: '',
  SF_END_BAN: '',
  SF_JG_APLY_YN: 'N',
  SF_JG_EDATE: '',
  SF_HAKGWA_NM: '전체',
  SF_GRADE_NM: '전체',
  SF_START_BAN_NM: '',
  SF_END_BAN_NM: '',
  SF_JG_APLY_YN_NM: '미적용',
}

var deduct_reload = true;

// 검색 조건 저장
const udfSetSearchCondition = (gu, name, val) => {
  if (gu === 'stdt') sc_stdt[name] = val;
  else if (gu === 'rule') sc_rule[name] = val;
  else if (gu === 'deduct') sc_deduct[name] = val;

  udfSetSearchConditionNm(gu, name, val);
}

// 검색 조건명 저장
const blankItem = ['SF_HAKGWA', 'SF_GRADE', 'SF_BAN', 'SF_KIND'];
const stdStatus = { 1: '재학', 2: '재학아님' };
const prmtYn = { Y: '학년진급前', N: '정상' };
const jgAplyYn = { Y: '적용', N: '미적용' };

const udfSetSearchConditionNm = (gu, name, val) => {
  $.each(blankItem, function (i, v) {
    if (name === v && val === '') val = '전체';
  });

  if (name === 'SF_GRADE' && val !== '전체') val = val + '학년';
  if (name === 'SF_BAN' && val !== '전체') val = val + '반';

  if (name === 'SF_START_BAN' && val !== '전체') val = val + '반';
  if (name === 'SF_END_BAN' && val !== '전체') val = val + '반';

  if (name === 'SF_STD_STATUS') val = stdStatus[val];
  if (name === 'SF_PRMT_YN') val = prmtYn[val];

  if (name === 'SF_KIND') val = clGuNm[val];

  if (name === 'SF_JG_APLY_YN') val = jgAplyYn[val];

  if (name.indexOf('_NM') < 0) {
    if (gu === 'stdt') sc_stdt[name + "_NM"] = val;
    else if (gu === 'rule') sc_rule[name + "_NM"] = val;
    else if (gu === 'deduct') sc_deduct[name + "_NM"] = val;
  }
}

// 검색 조건 reload, reset 설정
const udfSetScInfo = (gu, reload, reset) => {
  if (gu === 'stdt') {
    stdt_reload = reload;
    if (reset) udfResetScStdt();
  } else if (gu === 'rule') {
    rule_reload = reload;
    if (reset) udfResetScRule();
  } else if (gu === 'deduct') {
    deduct_reload = reload;
    if (reset) udfResetScDeduct();
  }
}

// 초기화
const udfResetScStdt = () => {
  sc_stdt = {
    SF_HAKGWA: '',
    SF_GRADE: '',
    SF_BAN: '',
    SF_STD_STATUS: '1',
    SF_PRMT_YN: 'N',
    searchKeyword: '',
    SF_HAKGWA_NM: '전체',
    SF_GRADE_NM: '전체',
    SF_BAN_NM: '전체',
    SF_STD_STATUS_NM: '재학',
    SF_PRMT_YN_NM: '정상',
  }
}

const udfResetScRule = () => {
  sc_rule = {
    SF_HAKGWA: '',
    SF_GRADE: '',
    SF_START_BAN: '',
    SF_END_BAN: '',
    SF_SDATE: '',
    SF_EDATE: '',
    SF_KIND: '',
    SF_KIND_SP: '',
    SF_KIND_EP: '',
    SF_CLRL_CD: '',
    SF_CLRL_NM: '',
    SF_HAKGWA_NM: '전체',
    SF_GRADE_NM: '전체',
    SF_START_BAN_NM: '',
    SF_END_BAN_NM: '',
    SF_KIND_NM: '전체',
    SF_CL_CD: '',
    SF_RL_searchkeyword: '',
  }
}

const udfResetScDeduct = () => {
  sc_deduct = {
    SF_HAKGWA: '',
    SF_GRADE: '',
    SF_START_BAN: '',
    SF_END_BAN: '',
    SF_JG_APLY_YN: 'N',
    SF_JG_EDATE: '',
    SF_HAKGWA_NM: '전체',
    SF_GRADE_NM: '전체',
    SF_START_BAN_NM: '',
    SF_END_BAN_NM: '',
    SF_JG_APLY_YN_NM: '미적용',
  }
}

// 상점/벌점(개인별) 검색어
var ruleHistorySearchKeyword = '';
var ruleHistory_relod = true;
const udfSetRuleHistorySearchKeyword = (val) => {
  ruleHistorySearchKeyword = val;
}

const udfSetRuleHistoryReload = (flag) => {
  ruleHistory_relod = flag;
  if (ruleHistory_relod) ruleHistorySearchKeyword = '';
}

// 학생 정보
var stdtInfo = {};
const udfSetStdtInfo = (info) => {
  stdtInfo = info;
}

// 교사 정보
var teacherInfo = {};
const udfSetTeacherInfo = (info) => {
  teacherInfo = info;
}

// 상벌점 정보
var ruleInfo = {};
const udfSetRuleInfo = (info) => {
  ruleInfo = info;
}

// 학생 정보 및 상벌점 조회
var stdtRule_reload = true;
const udfSetStdtRuleReload = (flag) => {
  stdtRule_reload = flag;
}

// 최근 행위항목코드 저장 내용 정보
var lastCdInfo = {};
const udfSetLastCdInfo = (info) => {
  lastCdInfo = info;
}

export {
  sc_stdt,
  stdt_reload,

  sc_rule,
  rule_reload,

  sc_deduct,
  deduct_reload,

  udfSetSearchCondition,
  udfSetScInfo,

  hakgwaList,
  udfSetHakgwaList,
  banArr,
  udfSetLastBan,

  ruleHistorySearchKeyword,
  udfSetRuleHistorySearchKeyword,
  ruleHistory_relod,
  udfSetRuleHistoryReload,

  stdtInfo,
  udfSetStdtInfo,

  teacherInfo,
  udfSetTeacherInfo,

  ruleInfo,
  udfSetRuleInfo,

  stdtRule_reload,
  udfSetStdtRuleReload,

  lastCdInfo,
  udfSetLastCdInfo,
}